
import EventCard from "@/components/event/EventCard"
import BlurredModal from "@/components/base/modal/BlurredModal"
import EventDetailCard from "@/components/event/EventDetailCard"
import { routeToEvent } from "@/helpers/routing"
import EventEditor from "@/components/event/EventEditor"
import eventService from "@/services/event.service"
import Modal from "@/components/base/modal/Modal"

export default {
    name: "EventListNonRetarded",
    components: {
        Modal,
        EventEditor,
        EventCard,
        BlurredModal,
        EventDetailCard,
    },
    emits: ["edit"],
    props: {
        events: {
            type: Array,
            required: true,
        },
        channelSlug: {
            type: String,
            required: true,
        },
        /** A selected event to be highlighted */
        selected: {
            type: Object,
            default: null,
        },
        allowEdit: {
            type: Boolean,
            default: true,
        },
    },
    data: () => {
        return {
            selectedEvent: null,
            viewedEvent: null,
            showEditor: false,
        }
    },
    computed: {
        channelId() {
            if (this.$auth.user.region) {
                return this.$auth.user.region.channel.id
            } else if (this.$auth.user.school) {
                return this.$auth.user.school.channel.id
            }
            return undefined
        },
        sortedEvents() {
            return [...this.events].sort(
                (e1, e2) => new Date(e1.start_at) - new Date(e2.start_at)
            )
        },
        editable() {
            return this.allowEdit && this.$can.editEvents(this.channelSlug)
        },
    },
    methods: {
        showEvent(event) {
            this.viewedEvent = event
            if (!event) {
                this.editEvent(null)
                return
            }
            /* Fake URL to event post */
            const eventRoute = routeToEvent(event)
            if (this.$route.fullPath != eventRoute) {
                window.history.pushState({}, "", eventRoute)
            }
        },
        isSelected(event) {
            return this.selected?.slug == event?.slug && event != null
        },
        closeModal() {
            this.viewedEvent = null
            /* Remove faked URL to event post */
            window.history.pushState({}, "", this.$route.fullPath)
        },
        async editEvent(event) {
            if (event) {
                this.loadingEvent = true
                this.showEditor = false
                event = await eventService.getEvent(event.slug)
            }
            this.showEditor = true
            this.loadingEvent = false
            this.selectedEvent = event
        },
        async onEventSave(event) {
            this.loadingEvent = true

            if (this.selectedEvent) {
                await eventService
                    .updateEvent(this.selectedEvent.slug, event)
                    .then((response) => {
                        this.events = this.events.map((e) =>
                            e.slug === response.slug ? response : e
                        )
                    })
                    .catch((err) => console.error(err))
            } else {
                await eventService
                    .createEvent({
                        ...event,
                        channel_id: this.channelId,
                    })
                    .then((response) => {
                        this.events.push(response)
                    })
                    .catch((err) => console.error(err))
            }
            this.loadingEvent = false
            this.closeEditor()
        },
        closeEditor() {
            this.selectedEvent = null
            this.showEditor = false
        },
    },
}
